module.exports = __webpack_public_path__ + "static/img/B02-辽宁省实验中学.f09179a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/B02-辽宁省实验中学.png
// module id = eR5m
// module chunks = 0